__turbopack_context__.v({
  "container": "Footer-module-scss-module__wcgw9G__container",
  "footer": "Footer-module-scss-module__wcgw9G__footer",
  "footer__about": "Footer-module-scss-module__wcgw9G__footer__about",
  "footer__about__content": "Footer-module-scss-module__wcgw9G__footer__about__content",
  "footer__about__logo": "Footer-module-scss-module__wcgw9G__footer__about__logo",
  "footer__badges": "Footer-module-scss-module__wcgw9G__footer__badges",
  "footer__contacts": "Footer-module-scss-module__wcgw9G__footer__contacts",
  "footer__contacts__block": "Footer-module-scss-module__wcgw9G__footer__contacts__block",
  "footer__contacts__email": "Footer-module-scss-module__wcgw9G__footer__contacts__email",
  "footer__contacts__item": "Footer-module-scss-module__wcgw9G__footer__contacts__item",
  "footer__contacts__phone": "Footer-module-scss-module__wcgw9G__footer__contacts__phone",
  "footer__contacts__socials": "Footer-module-scss-module__wcgw9G__footer__contacts__socials",
  "footer__docs__info": "Footer-module-scss-module__wcgw9G__footer__docs__info",
  "footer__navigation": "Footer-module-scss-module__wcgw9G__footer__navigation",
  "sm": "Footer-module-scss-module__wcgw9G__sm",
});
